var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { NumberPositiveFormat } from './positive';
import { language } from '@comall-backend-builder/core/lib/services';

var NumberPriceFormat = function (_super) {
  __extends(NumberPriceFormat, _super);

  function NumberPriceFormat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 对数据进行校验
   */


  NumberPriceFormat.prototype.validate = function (_rule, value, callback) {
    _super.prototype.validate.call(this, _rule, value, function (result) {
      callback(result ? language.getText('validation.number.price') : undefined);
    });
  };
  /**
   * 将数据格式化为符合 price 格式的 number 类型的值
   * 即最多保留小数点后两位（直接截去，而非四舍五入）
   */


  NumberPriceFormat.prototype.format = function (value) {
    value = _super.prototype.format.call(this, value);

    if (value !== undefined) {
      value = Math.floor(value * 100) / 100; // 只保留小数点后两位的值
    }

    return value;
  };

  return NumberPriceFormat;
}(NumberPositiveFormat);

export { NumberPriceFormat };